import React, { Component } from "react";

import {
  CCol,
  CRow,
  CButton,
  CTextarea,
  CLabel,
  CBadge,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { InputGroup, Input, FormGroup } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";
import Literarte from "../SlateComponents/Literarte";

import "../../scss/style2.scss";

class CorrectLiterarte extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      comment: "",
      criterions: [],
      value: [
        {
          type: "paragraph",
          children: [{ text: "" }]
        }
      ],
      pages: [],
      currentPage: 0,
      production_id: null
      // noteValue: "",
      // aux: ""
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    let obj = {
      id: this.props.id,
      user_id: this.props.user_id
    };

    axios
      .post(`${URL.api}literarte/production/singleView`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let pages = [];
        if (resp.data.data) {
          for (let i = 0; i < resp.data.data.pages.length; i++) {
            pages.push(JSON.parse(resp.data.data.pages[i].content));
          }
          this.setState({
            production_id: resp.data.data.id,
            criterions: resp.data.data.criterion.map(item => ({
              ...item,
              note: item.note || 0,
              comments: item.comments || "",
              noteValueStatus: 1
            })),
            pages,
            loading: false,
            value: pages[0],
            comment: resp.data.data.comments || ""
          });
        }
      });
  }

  onChangeComment = e => {
    let comment = e.target.value;
    this.setState({
      comment
    });
  };

  onChangeCriterionComment = (e, index) => {
    let comments = e.target.value;

    let criterions = [];
    this.state.criterions.forEach(criterion => {
      criterions.push(criterion);
    });

    criterions[index].comments = comments;

    this.setState({
      criterions
    });
  };

  onChangeCriterionNote = (e, index) => {
    let note = parseFloat(e.target.value);
    // eslint-disable-next-line react/no-access-state-in-setstate
    let criterions = [...this.state.criterions];

    if (note === 0 || (note && criterions)) {
      let maxNote = parseFloat(criterions[index].value);

      if (note < 0 || note > maxNote) {
        criterions[index].note = e.target.value;
        criterions[index].noteValueStatus = 2; // 0 - Valor inválido, 1 - Valor válido, 2 - Valor fora do intervalo
      } else {
        criterions[index].note = note;
        criterions[index].noteValueStatus = 1; // 0 - Valor inválido, 1 - Valor válido, 2 - Valor fora do intervalo
      }
    } else {
      criterions[index].note = e.target.value;
      criterions[index].noteValueStatus = 0; // 0 - Valor inválido, 1 - Valor válido, 2 - Valor fora do intervalo
    }

    this.setState({
      criterions
    });

    // let note = parseInt(e.target.value);

    // let criterions = [];
    // this.state.criterions.forEach((criterion) => {
    //     criterions.push(criterion);
    // })

    // if (note < 0) {
    //     note = 0;
    // } else if (note > criterions[index].value) {
    //     note = criterions[index].value;
    // }

    // criterions[index].note = note;

    // this.setState({
    //     criterions
    // })
  };

  changePage = index => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      value: this.state.pages[index],
      currentPage: index
    });
  };

  save = () => {
    let value = 0; // Nota total

    this.state.criterions.forEach(criterion => {
      if (criterion.note > 0) {
        value += parseFloat(criterion.note); // Cálculo da nota total
      }
    });

    let validCriterionNotes = this.state.criterions.reduce(
      (total, cur, index) =>
        total.status === 1 ? { status: cur.noteValueStatus, index } : total,
      { status: 1, index: 0 }
    );

    const { status, index } = validCriterionNotes;

    if (status === 1) {
      let obj = {
        id: this.state.production_id,
        value,
        comments: this.state.comment,
        criterions: this.state.criterions,
        loading: false,
        item_id: this.props.item_id,
        execution_id: this.props.execution_id,
        user_id: this.props.user_id
      };

      axios
        .post(`${URL.api}literarte/production_correct`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.props.onClose();
        });
    } else if (status === 0) {
      toastr.error(
        "Erro ao salvar!",
        `No critério ${index + 1} ("${
          this.state.criterions[index].name
        }"), complete o campo com um valor numérico`
      );
    } else if (status === 2) {
      toastr.error(
        "Erro ao salvar!",
        `No critério ${index + 1} ("${
          this.state.criterions[index].name
        }"), preencha com um valor de 0 a ${this.state.criterions[index].value}`
      );
    }
  };

  prevPage() {
    const index = Math.max(this.state.currentPage - 1, 0);
    this.setState(state => ({
      value: state.pages[index],
      currentPage: index
    }));
  }

  nextPage() {
    const index = Math.min(
      this.state.currentPage + 1,
      this.state.pages.length - 1
    );
    this.setState(state => ({
      value: state.pages[index],
      currentPage: index
    }));
  }

  render() {
    if (this.state.loading) {
      return (
        <CModal
          onClose={this.props.onClose}
          show={this.props.show}
          centered
          size="xl w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Correção do Literarte</CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-3 d-flex align-items-center justify-content-center"
            style={{ overflow: "auto" }}
          >
            <Loading />
          </CModalBody>
        </CModal>
      );
    }

    return (
      <CModal
        onClose={this.props.onClose}
        show={this.props.show}
        centered
        size="xl w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Correção do Literarte</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <div
            style={{
              height: "100%",
              backgroundColor: "#f6f8f9",
              width: "30rem"
            }}
            className="p-3 overflow-auto d-flex flex-column"
          >
            <FormGroup className="mb3">
              <CLabel>Comentários</CLabel>
              <InputGroup>
                <CTextarea
                  rows={6}
                  value={this.state.comment}
                  onChange={e => this.onChangeComment(e)}
                  placeholder="Digite os comentários sobre a produção"
                />
              </InputGroup>
            </FormGroup>
            {this.state.criterions.map((criterion, index) => (
              <React.Fragment key={criterion.id}>
                <FormGroup className="mb3">
                  <CLabel>{`${criterion.name} (${criterion.value})`}</CLabel>
                  <CRow>
                    <CCol lg="3">
                      <InputGroup>
                        <Input
                          type="number"
                          className=".no-spinner"
                          value={criterion.note}
                          onChange={e => this.onChangeCriterionNote(e, index)}
                        />
                      </InputGroup>
                    </CCol>
                    <CCol lg="9">
                      <InputGroup>
                        <Input
                          type="text"
                          value={criterion.comments}
                          onChange={e =>
                            this.onChangeCriterionComment(e, index)
                          }
                          placeholder="Comentários do critério"
                        />
                      </InputGroup>
                    </CCol>
                  </CRow>
                </FormGroup>
              </React.Fragment>
            ))}
            {/* <div style={{display: 'flex', marginBottom: '10px'}}>
                    {this.state.pages.map((page, index) => {
                        return (
                            <div
                                key={index}
                                style={{flexDirection: 'column', marginRight: '10px'}}
                            >
                                <div
                                    style={{cursor: 'pointer', backgroundColor: '#E2E2E2', height: '150px', width: '100px', border: '1px solid black', display: 'flex', alignItems: 'center', justifyContent: 'center', }}
                                >
                                    
                                    {index === this.state.currentPage? 
                                        null
                                    :
                                        <div style={{fontSize: '30px'}}>
                                            <i className={"fa fa-pencil-square-o fa-10x"} style={{color: 'black', cursor: 'pointer'}} onClick={() => this.changePage(index)}></i>
                                        </div>
                                    }
                                    
                                </div>
                                <div style={{textAlign: 'center'}}>
                                    {`Página ${index + 1} `}
                                </div>
                            </div>
                        )
                    })}
                </div>
                */}
            <CButton
              block
              size="lg"
              color="primary"
              style={{ marginTop: "auto" }}
              onClick={() => this.save()}
            >
              Salvar
            </CButton>
          </div>
          <div
            style={{
              height: "100%",
              backgroundColor: "#ffffff",
              flex: 1,
              boxShadow:
                "-3px 0px 6px -3px rgba(60, 64, 67, 0.15), 3px 0px 6px -3px rgba(60, 64, 67, 0.15)",
              position: "relative"
            }}
            className="overflow-auto"
          >
            <CBadge
              color="dark"
              className="p-3 position-absolute d-flex align-items-center"
              style={{ top: "1rem", right: "1rem" }}
            >
              <i
                className="fa fa-chevron-left cursor"
                onClick={() => this.prevPage()}
              ></i>
              <div
                className="mx-3"
                style={{ fontSize: "14px", marginBottom: "1px" }}
              >
                {this.state.currentPage + 1}/{this.state.pages.length}
              </div>
              <i
                className="fa fa-chevron-right cursor"
                onClick={() => this.nextPage()}
              ></i>
            </CBadge>
            <Literarte value={this.state.value} edit={false} />
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CorrectLiterarte);
